<template>
  <v-app>
    <div
      v-if="loading === true"
      class="ma-5"
    >
      <v-progress-circular
        :size="70"
        :width="10"
        color="blue"
        indeterminate
      />
      <br>
      お客様の情報を確認中です。<br>
      処理が完了するまでお待ちください。
    </div>
  </v-app>
</template>

<script>
import { Firebase } from "../config/firebase";
export default {
  name: "PatientPri",

  data() {
    return {
      loading: true,
      image_url: "",
      clinic: null,
      user: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    user_id() {
      return this.$store.getters.user.uid;
    },
  },

  created: async function () {
    try {
      await this.fetchClinics();
    } catch (e) {
      this.error = true;
      console.log(e);
    } finally {
      this.loading = false;
    }
    this.loading = false;
    try {
      await this.fetchUsers();
    } catch (e) {
      this.error = true;
      console.log(e);
    } finally {
      this.loading = false;
    }
    this.loading = false;
  },
  methods: {
    fetchUsers: async function () {
      const userRef = await Firebase.firestore()
        .collection("Users")
        .doc(this.$store.getters.user.uid);
      await userRef.get().then((doc) => {
        if (doc.exists) {
          this.user = doc.data();
          this.user.id = doc.id;
        } else {
          console.log("No user document!");
        }
        this.error = true;
      });
    },
    fetchClinics: async function () {
      try {
        const clinicRef = await Firebase.firestore()
          .collection("Clinics")
          .doc(this.id);
        await clinicRef.get().then((doc) => {
          if (doc.exists) {
            this.clinic = doc.data();
            this.clinic.id = doc.id;
          } else {
            console.log("No clinic document!");
          }
          this.error = true;
        });
        if (this.clinic.is_form == true) {
          this.$router.push({ path: "/patient_form_regster/" + this.id });
        } else {
          this.$router.push({ path: "/patient_regster/" + this.id });
        }
      } catch (e) {
        this.error = true;
        this.$router.push({
          name: "error",
          params: { message: "表示できません。" },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
